// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__9MHAp","colMin":"styles_colMin__6b5-f","colCheckbox":"styles_colCheckbox__3RjRE"};